import React from "react";
import Select from "react-select";

const customStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: "28px",
    fontSize: "12px",
    borderColor: state.isFocused ? "var(--color-primary)" : "var(--color-border)",
    boxShadow: state.isFocused ? "0 0 0 2px color-mix(in srgb, var(--color-primary) 20%, transparent)" : "none",
    borderRadius: "4px",
    "&:hover": { borderColor: state.isFocused ? "var(--color-primary)" : "var(--color-base-disabled)" },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 8px",
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
    fontSize: "12px",
  }),
  placeholder: (base) => ({
    ...base,
    fontSize: "12px",
    color: "var(--color-base-disabled)",
  }),
  singleValue: (base) => ({
    ...base,
    fontSize: "12px",
  }),
  menu: (base) => ({
    ...base,
    fontSize: "12px",
    zIndex: 10,
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: "200px",
  }),
  groupHeading: (base) => ({
    ...base,
    fontSize: "10px",
    fontWeight: 600,
    color: "var(--color-base-disabled)",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    padding: "6px 8px 2px",
    marginBottom: 0,
  }),
  option: (base, state) => ({
    ...base,
    padding: "4px 8px",
    fontSize: "12px",
    backgroundColor: state.isFocused ? "var(--color-primary-light)" : "transparent",
    fontWeight: state.isSelected ? 600 : 400,
    color: "var(--color-base)",
    cursor: "pointer",
    "&:active": { backgroundColor: "var(--color-primary-light)" },
  }),
  indicatorSeparator: () => ({ display: "none" }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "0 4px",
    color: "var(--color-base-disabled)",
    "&:hover": { color: "var(--color-base-muted)" },
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: "0 4px",
    color: "var(--color-base-disabled)",
    "&:hover": { color: "var(--color-base-muted)" },
  }),
  loadingMessage: (base) => ({
    ...base,
    fontSize: "12px",
    color: "var(--color-base-muted)",
  }),
  noOptionsMessage: (base) => ({
    ...base,
    fontSize: "12px",
    color: "var(--color-base-disabled)",
  }),
};

export default function CableCombobox({
  groups,
  value,
  placeholder,
  onChange,
  isLoading,
  isClearable = false,
  filterOption,
}) {
  return (
    <Select
      classNamePrefix="cable-combobox"
      options={groups}
      value={value}
      placeholder={placeholder}
      onChange={onChange}
      isSearchable
      isClearable={isClearable}
      isLoading={isLoading}
      menuPlacement="auto"
      noOptionsMessage={() => "No cables found"}
      styles={customStyles}
      {...(filterOption ? { filterOption } : {})}
    />
  );
}
